import React from 'react';

const FormattedTax = ({ tax }) => {

    const formattedTax = new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(tax);

    return <span>{formattedTax}</span>;
};

export default FormattedTax;